import React, { FC } from 'react';
import { InventoryStatusCode } from '@/lib/shopify';
import useProductContext from '@/context/ProductContext';
import { TypeProduct } from '@/core/generated-types';

interface InventoryStatusProps {
  inventoryStatus: InventoryStatusCode | null;
  product: TypeProduct | null;
}

const InventoryStatus: FC<InventoryStatusProps> = ({
  inventoryStatus,
  product,
}) => {
  const { inventoryStatusCopy } = useProductContext();
  const {
    fields: { backOrderMessage, outOfStockMessage },
  } = product as TypeProduct;

  let message = null;
  let className = '';

  switch (inventoryStatus) {
    case InventoryStatusCode.OUT_OF_STOCK:
      message = outOfStockMessage || inventoryStatusCopy?.outOfStock;
      className = 'text-red';
      break;

    case InventoryStatusCode.BACKORDER:
      message = backOrderMessage || inventoryStatusCopy?.backOrder;
      className = 'text-charcoal';
      break;

    case InventoryStatusCode.PRESALE:
      message = inventoryStatusCopy?.preSale;
      className = 'text-success';
      break;

    default:
      return null;
  }

  return message ? <span className={className}>{message}</span> : null;
};

export default InventoryStatus;
